export const UNITED_STATES = 'United States';
export const EARLY_ACCESS_TAG_NAME = 'Early Access';
export const DAY_MS = 1000 * 60 * 60 * 24;
export const HOUR_MS = 1000 * 60 * 60;
export const MINUTE_MS = 1000 * 60;
